import { z } from 'zod';
import { uuidSchema } from './common.js';
/**
 * Stakeholders (BP-12) — a stakeholder's position on the power (influence) x interest grid and its
 * derived quadrant, optionally scoped to a category. Lean first cut: name, role, influence + interest
 * (0..100), quadrant, notes. Shapes shared by the API (validation) and the web app (types).
 */
export const stakeholderQuadrantSchema = z.enum(['manage_closely', 'keep_satisfied', 'keep_informed', 'monitor']);
export const stakeholderSchema = z.object({
    id: uuidSchema,
    name: z.string(),
    role: z.string().nullable(),
    influence: z.number(),
    interest: z.number(),
    quadrant: stakeholderQuadrantSchema,
    categoryId: uuidSchema.nullable(),
    notes: z.string().nullable(),
    isDemo: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
/** POST /stakeholders — add a stakeholder to the register (source 'manual'). */
export const createStakeholderSchema = z
    .object({
    name: z.string().trim().min(1).max(160),
    role: z.string().trim().max(160).optional(),
    influence: z.number().min(0).max(100).optional(),
    interest: z.number().min(0).max(100).optional(),
    quadrant: stakeholderQuadrantSchema.optional(),
    categoryId: uuidSchema.optional(),
    notes: z.string().trim().max(1000).optional(),
})
    .strict();
/** PATCH /stakeholders/:id — move on the grid / re-quadrant / annotate. */
export const patchStakeholderSchema = z
    .object({
    name: z.string().trim().min(1).max(160).optional(),
    role: z.string().trim().max(160).nullable().optional(),
    influence: z.number().min(0).max(100).optional(),
    interest: z.number().min(0).max(100).optional(),
    quadrant: stakeholderQuadrantSchema.optional(),
    categoryId: uuidSchema.nullable().optional(),
    notes: z.string().trim().max(1000).nullable().optional(),
})
    .strict();
//# sourceMappingURL=stakeholders.js.map